import api from "./api";
import { AdminUser, AdminRole, AdminPermission, UserAccessLog, AdminLeader } from "../../types/admin";

const V1 = "/api/v1";

export interface AdminPage {
  page: number;
  page_size: number;
  total_pages: number;
}

export const adminApi = {

  listUsers: async (params?: { search?: string; is_active?: boolean; exclude_candidates?: boolean; page?: number; page_size?: number }) => {
    const response = await api.get<{ users: AdminUser[]; total: number } & AdminPage>(`${V1}/users`, { params });
    return response.data;
  },

  createUser: async (payload: { email: string; name: string; country?: string; roles?: number[] }) => {
    const response = await api.post<AdminUser>(`${V1}/users`, payload);
    return response.data;
  },

  getUser: async (id: number) => {
    const response = await api.get<AdminUser>(`${V1}/users/${id}`);
    return response.data;
  },

  updateUser: async (id: number, payload: { name?: string; country?: string; roles?: number[] }) => {
    const response = await api.patch<AdminUser>(`${V1}/users/${id}`, payload);
    return response.data;
  },

  toggleActive: async (id: number) => {
    const response = await api.patch<AdminUser>(`${V1}/users/${id}/active`);
    return response.data;
  },

  listRoles: async (params?: { page?: number; page_size?: number }) => {
    const response = await api.get<{ roles: AdminRole[]; total: number } & AdminPage>(`${V1}/roles`, { params });
    return response.data;
  },

  createRole: async (payload: { name: string; description?: string }) => {
    const response = await api.post<AdminRole>(`${V1}/roles`, payload);
    return response.data;
  },

  updateRole: async (id: number, payload: { name?: string; description?: string }) => {
    const response = await api.patch<AdminRole>(`${V1}/roles/${id}`, payload);
    return response.data;
  },

  deleteRole: async (id: number) => {
    await api.delete(`${V1}/roles/${id}`);
  },

  setRolePermissions: async (id: number, permissionIds: number[]) => {
    const response = await api.put<AdminRole>(`${V1}/roles/${id}/permissions`, {
      permission_ids: permissionIds,
    });
    return response.data;
  },

  listPermissions: async (params?: { search?: string; page?: number; page_size?: number }) => {
    const response = await api.get<{ permissions: AdminPermission[]; total: number } & AdminPage>(`${V1}/permissions`, { params });
    return response.data;
  },

  createPermission: async (payload: { code: string; description?: string }) => {
    const response = await api.post<AdminPermission>(`${V1}/permissions`, payload);
    return response.data;
  },

  updatePermission: async (id: number, payload: { code?: string; description?: string }) => {
    const response = await api.patch<AdminPermission>(`${V1}/permissions/${id}`, payload);
    return response.data;
  },

  deletePermission: async (id: number) => {
    await api.delete(`${V1}/permissions/${id}`);
  },

  getUserAccessLogs: async (userId: number) => {
    const response = await api.get<{ logs: UserAccessLog[]; total: number }>(
      `${V1}/users/${userId}/access-logs`
    );
    return response.data;
  },

  listLeaders: async (params?: { search?: string; page?: number; page_size?: number }) => {
    const response = await api.get<{ leaders: AdminLeader[]; total: number } & AdminPage>(`${V1}/leaders`, { params });
    return response.data;
  },

  createLeader: async (payload: { nome_lider: string; email_lider?: string | null; cpf_lider?: string | null }) => {
    const response = await api.post<AdminLeader>(`${V1}/leaders`, payload);
    return response.data;
  },

  syncLeaders: async () => {
    const response = await api.post<{ synced: number; total: number }>(`${V1}/leaders/sync`);
    return response.data;
  },
};